interface AdminPageContainerProps {
  children: React.ReactNode
}

export default function AdminPageContainer({ children }: AdminPageContainerProps) {
  return (
    <div className="min-h-screen flex-1 px-4 py-4 sm:px-6 lg:px-8">
      {children}
    </div>
  )
} 